module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-lg-12 col-md-12 col-sm-12"
  }, [_c('audience-profile-chart', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data.audienceProfile
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12"
  }, [_c('cross-platform-engagement-chart', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data.crossPlatformEngagement
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14f898dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/ProfilesCharts.vue
// module id = 3152
// module chunks = 3